@if (corporateTaxEntity$ | async) {
  <form [formGroup]="innovatieboxFg">
    <div formArrayName="innovaties">
      @for (item of innovaties.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row mb-1">
          <div class="col-auto">
            <snelstart-ui-text-form-control
              [label]="i === 0 ? 'Omschrijving' : ''"
              [required]="true"
              class="custom-input-250"
              formControlName="omschrijving"
              id="omschrijving"
            >
            </snelstart-ui-text-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-number-form-control
              [label]="i === 0 ? 'Voortbrengingskosten' : ''"
              [showAllDecimals]="false"
              align="right"
              class="custom-input-150"
              formControlName="voortbrengingskosten"
              id="voortbrengingskosten"
              prefix="€"
            >
            </snelstart-ui-number-form-control>
          </div>
          <div class="col-auto">
            <snelstart-ui-button
              (click)="verwijderRij(i)"
              [class]="i === 0 ? 'firstrowbutton' : ''"
              icon="trash"
              iconType="light"
              id="buttonDelete"
              size="medium"
              type="secondary"
            >
            </snelstart-ui-button>
          </div>
        </div>
      }
    </div>
  </form>

  <snelstart-ui-button
    (click)="addRij()"
    [id]="innovaties.length === 0 ? '1' : '2'"
    class="snelstart-ui-button pb-3"
    icon="plus"
    type="link"
  >Innovatie toevoegen
  </snelstart-ui-button>

  <hr class="line-color">

  @if (!bijzonderhedenVisible) {
    <snelstart-ui-button
      (click)="showBijzonderheden()"
      class="snelstart-ui-button pb-3"
      icon="plus"
      id="3"
      type="link"
    >Bijzonderheden toevoegen
    </snelstart-ui-button>
  }

  @if (bijzonderhedenVisible) {
    <form [formGroup]="innovatieboxBijzonderhedenFg">
      <snelstart-ui-select-form-control
        [options]="optionsJaNee"
        class="custom-input-250"
        formControlName="vaststellingsOvereenkomst"
        id="vaststellingsOvereenkomst"
        label="Vaststellingsovereenkomst?"
      >
      </snelstart-ui-select-form-control>

      <snelstart-ui-select-form-control
        [options]="optionsJaNee"
        class="custom-input-250"
        formControlName="forfaitaireRegeling"
        id="forfaitaireRegeling"
        label="Forfaitaire regeling?"
      >
      </snelstart-ui-select-form-control>

      <snelstart-ui-number-form-control
        [showAllDecimals]="false"
        align="right"
        class="custom-input-250"
        formControlName="saldoInTeLopenVoortbrengingskosten"
        id="saldoInTeLopenVoortbrengingskosten"
        label="In te lopen voortbrengingskosten"
        prefix="€"
      >
      </snelstart-ui-number-form-control>

      <snelstart-ui-number-form-control
        [showAllDecimals]="false"
        align="right"
        class="custom-input-250"
        formControlName="voordelenBovenDrempel"
        id="voordelenBovenDrempel"
        label="Voordelen boven drempel"
        prefix="€"
      >
      </snelstart-ui-number-form-control>

      <snelstart-ui-number-form-control
        [showAllDecimals]="false"
        align="right"
        class="custom-input-250"
        formControlName="winstUitVoordelenNietToegewezen"
        id="winstUitVoordelenNietToegewezen"
        label="Terugname voordelen"
        prefix="€"
      >
      </snelstart-ui-number-form-control>
    </form>
  }
}
